import { withCompInfo } from '@wix/editor-elements-integrations'
import type { CatharsisImageMask } from '../WPhoto/WPhoto.mapper'
import { getImageMaskCSSVars } from '../WPhoto/WPhoto.mapper'
import { getSvgStringForMask } from '../VectorImage/VectorImageHelpers'
import type { ImageXDefinition, ImagexCSS, ImageXDataItem } from './ImageX'

export const css = withCompInfo<ImagexCSS, ImageXDefinition>()(
	['compData'],
	({ compData }: { compData: ImageXDataItem }) => {
		const svgId = compData.mask?.svgId
		const svgMaskData: CatharsisImageMask = {
			svgId,
			x: 0,
			y: 0,
			width: 100,
			height: 100,
			mode: 'alpha',
			flip: 'none',
			rotate: 0,
		}

		if (compData.resolvedSvg) {
			svgMaskData.svgContent = getSvgStringForMask({
				svgInfo: compData.resolvedSvg.info,
				svgString: compData.resolvedSvg.content,
				flip: svgMaskData.flip,
			})
		}

		return svgId ? getImageMaskCSSVars(svgMaskData) : {}
	}
)
